import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProjectNodeType } from '@/api/Project/types'

export type ModelPipelineResultSlice = {
  resultNodeId: string
  selectedNodeType: ProjectNodeType
  selectedNodeId: string
}

const INITIAL_STATE: ModelPipelineResultSlice = {
  resultNodeId: '',
  selectedNodeType: '',
  selectedNodeId: '',
}

export const modelPipelineResultSlice = createSlice({
  name: 'modelPipelineResult',
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedNode(state, action: PayloadAction<{ selectedNodeType: ProjectNodeType, selectedNodeId: string }>) {
      state.selectedNodeType = action.payload.selectedNodeType
      state.selectedNodeId = action.payload.selectedNodeId
    },
  },
})

export const { setSelectedNode } = modelPipelineResultSlice.actions

export default modelPipelineResultSlice.reducer
